import React, { useMemo } from 'react';
import Icon from '../../../../../../components/Icon';
import TableAdvanced from '../../../../../../components/TableAdvanced';
import Rating from '../../../../../../components/Rating';
import { ApiWorkers } from '../../../../../../api/workers';
import { useApi } from '../../../../../../hooks/useApi';
import Loader from '../../../../../../components/Loader';
import User from '../../../../../../components/User';
import IconWrap from '../../../../../../components/IconWrap';
import { filterDataByString, parseWorkers } from '../../../../../../utils/helpers';
import { useTranslation } from 'react-i18next';

const WorkersTable = ({ rowTo, searchText }) => {
    const { t } = useTranslation()
    // Setup request
    const [{ data: workersData, loading: workersLoading }] = useApi(ApiWorkers.get);
    // Memoize data
    const workers = useMemo(
        () => parseWorkers(workersData),
        [workersData]
    );

    const workersFiltered = useMemo(
        () => {
            return filterDataByString(workers, searchText, worker => worker?.worker?.name);
        },
        [workers, searchText]
    );

    const data = useMemo(() => workersFiltered, [workersFiltered]);

    const columns = useMemo(() => [
        {
            Header: t('Pracownik'),
            accessor: 'username',
            Cell: ({ row }) => {
                return (
                    <User
                        user={{
                            name: row.original?.worker?.name,
                            avatarSrc: row.original?.worker?.avatar
                        }}
                        hideDelete
                    />
                )
            }
        },
        {
            Header: t('Adres zamieszkania'),
            accessor: 'address'
        },
        {
            Header: t('Ranking'),
            accessor: 'rating',
            Cell: ({ cell: { value } }) => {
                return (
                    <Rating rate={value} />
                )
            },
            width: 60
        },
        {
            Header: t('Adres email'),
            accessor: 'email'
        },
        {
            Header: t('Aktywny student'),
            accessor: 'student', 
            width: 60
        },
        {
            Header: t('Telefon'),
            accessor: 'phone',
           
        },
        {
            Header: () => null,
            id: 'expander',
            disableResizing: true,
            Cell: () => (
                <IconWrap rotate={90} align="right">
                    <Icon name="arrow" />
                </IconWrap>
            ),
            width: 30
        },
    ], [t]);

    return (
        <>
            <TableAdvanced
                columns={columns}
                data={data}
                rowTo={rowTo}
            />
            <Loader show={workersLoading} />
        </>
    )
}

export default WorkersTable;
